module.exports = __webpack_public_path__ + "assets/images/template/project/photo-3.jpg?v=208c5443";